import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\VersionNote\UpdateVersionNoteController::__invoke
* @see app/Http/Controllers/VersionNote/UpdateVersionNoteController.php
* @route '/api/add-unread-version'
*/
const UpdateVersionNoteController = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateVersionNoteController.url(options),
    method: 'put',
})

UpdateVersionNoteController.definition = {
    methods: ["put"],
    url: '/api/add-unread-version',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\VersionNote\UpdateVersionNoteController::__invoke
* @see app/Http/Controllers/VersionNote/UpdateVersionNoteController.php
* @route '/api/add-unread-version'
*/
UpdateVersionNoteController.url = (options?: RouteQueryOptions) => {
    return UpdateVersionNoteController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\VersionNote\UpdateVersionNoteController::__invoke
* @see app/Http/Controllers/VersionNote/UpdateVersionNoteController.php
* @route '/api/add-unread-version'
*/
UpdateVersionNoteController.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateVersionNoteController.url(options),
    method: 'put',
})

export default UpdateVersionNoteController